import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// A tab left open across a deploy still points at the previous build's lazy chunks (removed by the deploy): when a
// screen's chunk fails to load, reload once to get the new build instead of showing an error page.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'reloadedForNewBuild';
  try {
    if (sessionStorage.getItem(key) === location.pathname) return; // already tried for this page — show the error
    sessionStorage.setItem(key, location.pathname);
  } catch { /* storage blocked: still try once */ }
  event.preventDefault();
  location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
